import UIDs from "../../../../UIDs";

const uid = UIDs.screens.account.oldlogin;

const ActionTypes = {
    // Initialize
    INITIALIZE_ASYNC: `${uid}.initializeAsync`,
    INITIALIZE_SUCCESS: `${uid}.initializeSuccess`,
    INITIALIZE_FAILURE: `${uid}.initializeFailure`,

    // Temp Token Login
    TEMP_TOKEN_LOGIN_ASYNC: `${uid}.tempTokenLoginAsync`,
    TEMP_TOKEN_LOGIN_SUCCESS: `${uid}.tempTokenLoginSuccess`,
    TEMP_TOKEN_LOGIN_FAILURE: `${uid}.tempTokenLoginFailure`,

    // Get Schools
    GET_SCHOOLS_ASYNC: `${uid}.getSchoolsAsync`,
    GET_SCHOOLS_SUCCESS: `${uid}.getSchoolsSuccess`,
    GET_SCHOOLS_FAILURE: `${uid}.getSchoolsFailure`,

    // Init School Login
    INIT_SCHOOL_LOGIN_ASYNC: `${uid}.initSchoolLoginAsync`,
    INIT_SCHOOL_LOGIN_SUCCESS: `${uid}.initSchoolLoginSuccess`,
    INIT_SCHOOL_LOGIN_FAILURE: `${uid}.initSchoolLoginFailure`,

    GET_MATCHED_SCHOOLS_ASYNC: `${uid}.getMatchedSchoolsAsync`,
    GET_MATCHED_SCHOOLS_SUCCESS: `${uid}.getMatchedSchoolsSuccess`,
    GET_MATCHED_SCHOOLS_FAILURE: `${uid}.getMatchedSchoolsFailure`,

    // Update screen state
    UPDATE_SCREEN_STATE: `${uid}.updateScreenState`,

    // Handle iframe login
    HANDLE_IFRAME_LOGIN: `${uid}.handleIframeLogin`,

    // Handle postMessage
    HANDLE_POST_MESSAGE: `${uid}.handlePostMessage`,
};

export { ActionTypes };
